const scheduleSwiper = () => {
    const swipers = document.querySelectorAll('.swiper');

    if (!swipers.length) {
        return;
    }

    const loadSwiper = () => import(/* webpackChunkName: "theme-swiper" */ './swiper-runtime.js')
        .catch((error) => console.error('[swiper-loader] Impossible de charger Swiper', error));

    if (!('IntersectionObserver' in window)) {
        loadSwiper();
        return;
    }

    const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) {
            return;
        }

        observer.disconnect();
        loadSwiper();
    }, {
        rootMargin: '100% 0px',
    });

    swipers.forEach((swiper) => {
        const target = swiper.closest('.swiper-parent') || swiper;
        observer.observe(target);
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSwiper, { once: true });
} else {
    scheduleSwiper();
}
